<template>
    <div class="chat-input d-flex flex-column">
        <div class="d-block justify-content-end align-items-end text-right" v-if="sending" style="margin-bottom: 0px;">
            <i class="fas fa-spinner fa-spin"></i><span> Sending...</span>
        </div>
      <textarea
        class="form-control"
        v-model="message"
        :disabled="status === 'resolved'"
        :readonly="locked || sending"
        placeholder="Type a message..."
        rows="5"
        v-on:keyup.enter.exact="onSend"
      ></textarea>
      <div class="d-flex justify-content-between">
        <file-upload @upload="onUpload" :disabled="cannotSend || !uploadable"></file-upload>
        <send-button @click="onSend" :disabled="cannotSend || sending"></send-button>
      </div>
    </div>
</template>
  
<script>
    import FileUpload from './FileUpload.vue'
    import SendButton from './SendButton.vue'
    
    export default {
        name: 'ChatInput',
        components: { FileUpload, SendButton },
        props: {
            status: {
                type: String,
                required: true
            },
            sending: {
                type: Boolean,
                required: true
            },
            uploadable: {
                type: Boolean,
                default: true
            },
            locked: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return { message: '' }
        },
        computed: {
            cannotSend() {
                return this.status === 'resolved' || this.locked
            }
        },
        methods: {
            onSend() {
                if (this.cannotSend || this.sending) {
                    return
                }

                this.$emit('send', this.message)
            },
            clear() {
                this.message = ''
            },
            onUpload(file) {
                this.$emit('upload', file)
            }
        }
    }
</script>
  
<style scoped>
    .chat-input {
        width: 100%;
        gap: 2rem;
    }
    .chat-input textarea {
        height: 10rem;
        font-size: 1.4rem;
        resize: none; 
        vertical-align: top;
    }
  </style>
  